import React from 'react';
import {GradeColors} from '../config';
import {processBolt,BoltKeyList} from '../utils/bolt'

import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import locale from '../locale'

const BoltItem = ({id,note})=>{
  let {type,year,style,testDate,testNote} = processBolt(note)

  return (
      <TableRow>
        <TableRowColumn style={style}>{id}</TableRowColumn>
        <TableRowColumn style={style}>{type}</TableRowColumn>
        <TableRowColumn style={style}>{year}</TableRowColumn>
        <TableRowColumn style={style}>{testDate}</TableRowColumn>
        <TableRowColumn style={style}>{testNote}</TableRowColumn>
      </TableRow>
    )
}

export default class BoltInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange(expanded) {
    this.setState({expanded: expanded});
  };

  getBoltList({bolts,pitchList}){
    if(bolts){
      return BoltKeyList.filter(key=>!!bolts[key]).map(id=>({id,note:bolts[id]}))
    }
    if(pitchList){
      let list = []
      pitchList.forEach(({bolts},index)=>{
        list = list.concat(BoltKeyList.filter(key=>!!bolts[key])
          .map(id=>({id:('P'+(index+1)+' '+id),note:bolts[id]})))
      })
      return list
    }
  }

  render() {
    let list = this.getBoltList(this.props.route)
    if(!list)
      return <div/>
    return (
      <Table >
        <TableHeader
          adjustForCheckbox={false}
          displaySelectAll={false}
          enableSelectAll={false}>
          <TableRow>
            <TableHeaderColumn>Bolt ID</TableHeaderColumn>
            <TableHeaderColumn>{locale.R.boltType}</TableHeaderColumn>
            <TableHeaderColumn>{locale.R.boltYear}</TableHeaderColumn>
            <TableHeaderColumn>{locale.R.testDate}</TableHeaderColumn>
            <TableHeaderColumn>{locale.R.testResult}</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {list.map(({id,note})=><BoltItem key={id} id={id} note={note}/>)}
        </TableBody>
    </Table>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/BoltInfo.js
 **/